<template>
  <div class="entry-info">
    <div style="padding: 16px 16px 0 16px;">
      <div class="project">
        <div class="top">
          <div class="left">
            <div class="group">
              <span class="entryType" v-if="project.publicSignUp === 0 && project.allowTeamSignup === 1">邀请</span>
              <span class="group-name"> {{ project.group }}</span>
            </div>
            <div class="row">
              <div class="base-box" style="margin-right: 6px">
                <span v-if="project.unitType === 0" style="font-size: 12px; color: #FF652A;">队</span>
                <span v-else-if="project.unitType === 1" style="font-size: 12px; color: #FF652A;">人</span>
                <span v-else style="font-size: 12px; color: #FF652A;">多</span>
              </div>
              <div class="base-box" v-if="project.genderLimit == 1" style="margin-right: 6px">
                <img src="../../../assets/boy.png" style="width: 20px; height: 20px;">
              </div>
              <div class="base-box" v-else-if="project.genderLimit == 2" style="margin-right: 6px">
                <img src="../../../assets/girl.png" style="width: 20px; height: 20px;">
              </div>
              <div class="base-box" v-else-if="project.genderLimit == 0" style="margin-right: 6px; width: 34px;">
                <span style="font-size: 12px; color: #FF652A;">男/女</span>
              </div>
              <div class="base-box" v-else-if="project.genderLimit == 3" style="margin-right: 6px; width: 30px;">
                <span style="font-size: 12px; color: #FF652A;">不限</span>
              </div>
              <div class="info">
                参赛年龄：
                <span v-if="project.isOpenAgeLimit === 1">
                  {{ getFormatDate(project.maxAge) }}
                  {{ project.maxAge && project.minAge ? '~' : '' }}
                  {{ getFormatDate(project.minAge) }}
                </span>
                <span v-else>不限</span>
              </div>
            </div>
            <div class="row">
              <div class="info">选手人数：{{ project.teamMemberLeastCount }} ～ {{ project.teamMemberLimitCount }}</div>
            </div>
            <div v-if="project.isOpenCharge === 1">
              <div class="row">
                <div class="info">收费说明：{{ project.feeDescription }}</div>
              </div>
              <div class="row">
                <div class="info">收费方式：{{ getFeeMethodsLabel(project.feeMethod) }}</div>
              </div>
            </div>
          </div>
          <!--          <div class="right">-->
          <!--            <img src="../../../assets/right.png" style="width: 16px; height: 16px;" alt="">-->
          <!--          </div>-->
        </div>
        <div class="line"></div>
        <div class="bottom1">
          <div class="row">
            <div style="display: flex">
              <div class="col" v-if="project.isOpenCharge === 1 && project.feeMethod !== 0" style="margin-right: 8px;">
                <div class="icon">费</div>
                <div class="price">
                  <span v-if="project.feeAmount"> ¥{{ (project.feeAmount / 100).toFixed(2) }}</span>
                  <span v-else>¥0.00</span>
                </div>
              </div>
              <!--              <div class="col">-->
              <!--                <div class="icon">押</div>-->
              <!--                <div class="price" >-->
              <!--                  <span v-if="project.deposit">¥{{ (project.deposit / 100).toFixed(2) }}</span>-->
              <!--                  <span v-else>¥0.00</span>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
            <div class="col">
              <div class="num" v-if="project.isOpenTeamLimit === 1">剩余名额：{{ project.teamLimitCount - project.teamCount >=
                0 ? (project.teamLimitCount - project.teamCount) : 0 }}队</div>
              <div class="num" v-else>不限</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabs">
      <van-tabs v-model="active" background="#F6F6F8">
        <van-tab title="队伍" name="team">
          <van-form ref="teamForm" input-align="right" error-message-align="right">
            <div class="title">
              <div class="icon"></div>
              <span>队伍信息</span>
            </div>
            <van-field v-if="teamCheckboxes.name" label="队伍名称" v-model="team.name" placeholder="请输入队伍名称"
              :rules="[rulesWay('队伍名称不能为空')]"></van-field>
            <van-field v-if="teamCheckboxes.teamAlias" label="队伍简称" v-model="team.teamAlias" placeholder="请输入队伍简称"
              :rules="[rulesWay('队伍简称不能为空')]"></van-field>
            <van-field v-if="teamCheckboxes.delegation" label="代表团" v-model="team.delegation" placeholder="请选择代表团"
              :rules="[{ required: true, message: '请选择代表团' }]" readonly clickable @click="showDelegation = true" />
            <van-field v-if="teamCheckboxes.manager" label="主教练" v-model="team.manager" placeholder="请输入主教练姓名"
              :rules="[rulesWay('主教练不能为空')]"></van-field>
            <van-field v-if="teamCheckboxes.contactPerson" label="联系人" v-model="team.contactPerson" placeholder="请输入联系人姓名"
              :rules="[rulesWay('联系人不能为空')]"></van-field>
            <van-field v-if="teamCheckboxes.contactNumber" label="联系方式" v-model="team.contactNumber" placeholder="请输入联系方式"
              :rules="[rulesWay('联系方式不能为空'), { validator: checkMobile, message: '请输入正确的手机号' }]">
            </van-field>
            <van-field v-if="teamCheckboxes.badge" label="队徽" :rules="[rulesWay('队徽不能为空')]">
              <template #input>
                <van-uploader v-model="team.badgeList" max-count="1" :after-read="uploadBadge" @delete="deleteBadge" />
              </template>
            </van-field>
            <van-field v-if="teamCheckboxes.summary" label="队伍介绍" v-model="team.summary" placeholder="请输入队伍介绍"
              :rules="[rulesWay('队伍介绍不能为空')]"></van-field>
            <van-field v-if="teamCheckboxes.homeColor" label="主队颜色" v-model="team.homeClothesColor" placeholder="请选择主队颜色"
              :rules="[rulesWay('主队颜色不能为空')]" readonly clickable @click="showHomeColorFun">
              <template #input>
                <div v-if="team.homeClothesColor">
                  <img :src="team.homeClothesColorImg" style="width: 24px; height: 24px;" alt="">
                </div>
              </template>
            </van-field>
            <van-field v-if="teamCheckboxes.awayColor" label="客队颜色" v-model="team.awayClothesColor" placeholder="请输入客队颜色"
              :rules="[rulesWay('客队颜色不能为空')]" readonly clickable @click="showAwayColorFun">
              <template #input>
                <div v-if="team.awayClothesColor">
                  <img :src="team.awayClothesColorImg" style="width: 24px; height: 24px;" alt="">
                </div>
              </template>
            </van-field>
            <van-field v-if="teamCheckboxes.clothesId" label="球衣款式" v-model="team.clothesId" placeholder="请选择球衣款式"
              :rules="[rulesWay('球衣款式不能为空')]" readonly clickable @click="previewImg(team.clothesId)">
              <template #input>
                <div v-if="team.clothesId">
                  <van-image :src="imageView(getClothesImg(team.clothesId))" style="width: 24px; height: 24px;"
                    alt=""></van-image>
                </div>
              </template>
            </van-field>
            <div class="clotheses" v-if="teamCheckboxes.clothesId">
              <div class="clothes" v-for="(item, index) in clothes" :key="'clothes' + index" @click="chooseClothes(item)">
                <img class="img" :src="imageView(item.image)" alt="">
                <div class="disabled" v-if="item.isChoosed === 1">
                  <img class="lock" src="../../../assets/entry-list/lock.png" alt="">
                </div>
              </div>
            </div>
            <div v-if="teamCheckboxes.clothesColorDescription" style="padding: 0 18px;">
              <p style="font-size: 14px;margin: 12px 0 0 0;">主队队服颜色：</p>
              <van-field v-model="teamColor.home.a" label="上衣" placeholder="请输入上衣颜色"
                :rules="[{ required: true, message: '上衣颜色不能为空' }]"></van-field>
              <van-field v-model="teamColor.home.b" label="短裤" placeholder="请输入短裤颜色"
                :rules="[{ required: true, message: '短裤颜色不能为空' }]"></van-field>
              <van-field v-model="teamColor.home.c" label="球袜" placeholder="请输入球袜颜色"
                :rules="[{ required: true, message: '球袜颜色不能为空' }]"></van-field>
              <van-field v-model="teamColor.home.d" label-width="100px" label="守门员上衣" placeholder="请输入守门员上衣颜色"
                :rules="[{ required: true, message: '守门员上衣颜色不能为空' }]"></van-field>
              <van-field v-model="teamColor.home.e" label-width="100px" label="守门员短裤" placeholder="请输入守门员短裤颜色"
                :rules="[{ required: true, message: '守门员短裤颜色不能为空' }]"></van-field>
              <van-field v-model="teamColor.home.f" label-width="100px" label="守门员球袜" placeholder="请输入守门员球袜颜色"
                :rules="[{ required: true, message: '守门员球袜颜色不能为空' }]"></van-field>
              <p style="font-size: 14px;margin: 12px 0 0 0;">客队队服颜色：</p>
              <van-field v-model="teamColor.away.a" label="上衣" placeholder="请输入上衣颜色"
                :rules="[{ required: true, message: '上衣颜色不能为空' }]"></van-field>
              <van-field v-model="teamColor.away.b" label="短裤" placeholder="请输入短裤颜色"
                :rules="[{ required: true, message: '短裤颜色不能为空' }]"></van-field>
              <van-field v-model="teamColor.away.c" label="球袜" placeholder="请输入球袜颜色"
                :rules="[{ required: true, message: '球袜颜色不能为空' }]"></van-field>
              <van-field v-model="teamColor.away.d" label-width="100px" label="守门员上衣" placeholder="请输入守门员上衣颜色"
                :rules="[{ required: true, message: '守门员上衣颜色不能为空' }]"></van-field>
              <van-field v-model="teamColor.away.e" label-width="100px" label="守门员短裤" placeholder="请输入守门员短裤颜色"
                :rules="[{ required: true, message: '守门员短裤颜色不能为空' }]"></van-field>
              <van-field v-model="teamColor.away.f" label-width="100px" label="守门员球袜" placeholder="请输入守门员球袜颜色"
                :rules="[{ required: true, message: '守门员球袜颜色不能为空' }]"></van-field>
            </div>

            <van-field v-if="teamCheckboxes.insurancePolicy" :label="teamSignupFieldsLabel.insurancePolicy" placeholder="请上传参赛资料"
              :rules="[{ required: true, message: '请上传参赛资料' }]">
              <template #input>
                <van-uploader accept=".pdf,.zip,.rar" v-model="team.insurancePolicyList" max-count="1"
                  :after-read="uploadFile" @delete="deleteFile">
                  <div class="flex-center"
                    style="width: 80px;height: 80px;background-color: #F6F7F9;    justify-content: center;">
                    <img src="https://images.snsports.cn/FknqQ0fg-ftJt2PItoVb7GXeMAyj" />
                  </div>
                </van-uploader>
              </template>
            </van-field>
          </van-form>
          <div style="height: 115px; background-color: #F6F6F8;"></div>
          <div class="bottom" v-if="showButton">
            <div v-if="!teamId">
              <div style="display: flex; justify-content: center; padding: 0 0 8px 0">
                <van-checkbox v-model="allow" shape="square" icon-size="16px">
                  <span style="font-size: 13px; color: #8C8C8C">已阅读并承诺遵守本次赛事的赛事规程</span>
                </van-checkbox>
              </div>
              <van-button type="info" block @click="createTeam"
                style="background-color: #191919; color: #FFFFFF; height: 50px; border-radius: 25px">参赛报名</van-button>
            </div>
            <div v-else>
              <van-button type="info" block @click="updateTeam"
                style="background-color: #191919; color: #FFFFFF; height: 50px; border-radius: 25px">保存信息</van-button>
            </div>
          </div>
        </van-tab>
        <van-tab title="代表团官员" name="officer" :disabled="teamId === ''" v-if="teamCheckboxes.officer">
          <div class="limit">
            <div class="description">报名人数：{{ officers.length + ' / ' + project.maxOffice }}</div>
            <van-button round type="info" style="height: 24px;" @click="showOfficerFun('create')" v-if="showButton">
              <span style="font-size: 12px">添加</span>
            </van-button>
          </div>
          <div class="officers">
            <van-swipe-cell v-for="(item, index) in officers" :key="index">
              <div class="officer" @click="showOfficerFun('edit', item)">
                <div class="row">
                  <div class="left">
                    <div class="index">{{ index + 1 }} / {{ project.maxOffice }}</div>
                    <div class="name">{{ item.name }}</div>
                    <div class="boy-role" v-if="item.gender === '1'" style="margin-right: 6px">
                      <img src="../../../assets/boy.png" style="width: 20px; height: 20px;">
                      {{ item.role }}
                    </div>
                    <div class="girl-role" v-else-if="item.gender === '2'" style="margin-right: 6px">
                      <img src="../../../assets/girl.png" style="width: 20px; height: 20px;">
                      {{ item.role }}
                    </div>
                  </div>
                  <img src="../../../assets/right.png" alt="" style="width: 16px; height: 16px;">
                </div>
                <div class="row" style="margin-top: 18px">
                  <div class="left">
                    <span class="info">联系方式：</span>
                  </div>
                  <div class="info">{{ item.mobile }}</div>
                </div>
              </div>
              <template #right>
                <van-button @click="deleteOfficer(item.id)" square text="删除" type="danger" class="delete-button" />
              </template>
            </van-swipe-cell>
          </div>
        </van-tab>
        <van-tab title="队员" name="player" :disabled="teamId === ''">
          <div style="height: 12px; background-color: #FFFFFF;"></div>
          <div class="notice">
            <img src="../../../assets/notice.png" alt="" style="width: 20px;; height: 20px;">
            {{ getFormatDate(match.regUpdateEndDate) }} 前，您仍然可以通过“我的参赛”列表进入继续修改参赛名单
          </div>
          <div class="actions" v-if="showButton">
            <div class="action" @click="showPlayerFun('create')">
              <div class="item">
                <img src="../../../assets/addteam.png" style="width: 24px; height: 24px;">
              </div>
              <div class="item">手动添加</div>
            </div>
            <div class="action">
              <!--              <div class="item">-->
              <!--                <img src="../../../assets/common.png" style="width: 24px; height: 24px;">-->
              <!--              </div>-->
              <!--              <div class="item">-->
              <!--                常用人员选择-->
              <!--              </div>-->
            </div>
            <div class="action" @click="weChatShare" v-if="project.teamLeaderAddPlayerOnly === 0">
              <div class="item">
                <img src="../../../assets/wx.png" style="width: 24px; height: 24px;">
              </div>
              <div class="item">微信邀请</div>
            </div>
            <div v-else class="action"></div>
          </div>
          <div style="height: 12px; background-color: #F6F6F8;"></div>
          <div class="players">
            <van-swipe-cell v-for="(item, index) in players" :key="index">
              <div class="player" @click="showPlayerFun('edit', item, index)">
                <div class="row">
                  <div class="left">
                    <div class="index">{{ index + 1 }} / {{ project.teamMemberLimitCount }}</div>
                    <div class="true-name">{{ item.trueName }}</div>
                    <div v-if="item.gender === '1'" style="margin-right: 6px">
                      <img src="../../../assets/boy.png" style="width: 20px; height: 20px;">
                    </div>
                    <div v-else-if="item.gender === '2'" style="margin-right: 6px">
                      <img src="../../../assets/girl.png" style="width: 20px; height: 20px;">
                    </div>
                  </div>
                  <div style="display: flex; align-items: center">
                    <span style="font-size: 12px; color: #333333" v-if="project.feeMethod === 1">{{
                      getPaymentStatus(item.orderStatus) }}</span>
                    <div style="margin: 0 8px; font-size: 12px; color: #409EFF"
                      v-if="match.isOpenCharge === 1 && project.feeMethod === 1 && getPaymentStatus(item.orderStatus) === '待支付'"
                      @click.stop.prevent="doPay(item)">帮他支付</div>
                    <img src="../../../assets/right.png" alt="" style="width: 16px; height: 16px;">
                  </div>
                </div>
                <div class="row" style="margin-top: 18px">
                  <div class="left">
                    <span class="info">出生日期：</span>
                  </div>
                  <div>
                    <span class="info">
                      {{ getFormatDate(item.bmBirthday) }}{{ getAge(item.bmBirthday) }}
                    </span>
                  </div>
                </div>
                <div class="row" style="margin-top: 8px">
                  <div class="left">
                    <span class="info">{{ getCertTypeObj(item.certType).label }}：</span>
                  </div>
                  <div v-if="item.IDCardNo">
                    <span class="info">{{ item.IDCardNo.slice(0, 6) + ' **** **** **' +
                      item.IDCardNo.slice(item.IDCardNo.length - 2) }}</span>
                  </div>
                </div>
              </div>
              <template #right v-if="showButton">
                <van-button @click="deletePlayer(item.id)" square text="删除" type="danger" class="delete-button" />
              </template>
            </van-swipe-cell>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="popup">
      <van-popup class="player-popup" v-model="showPlayer" position="bottom" :style="{ height: '80%' }" round>
        <div style="padding-top: 12px; font-size: 18px; color: #191919; text-align: center">队员添加/编辑</div>
        <van-form ref="playerForm" input-align="right" error-message-align="right">
          <div class="title">
            <div class="icon"></div>
            <span>队员信息</span>
          </div>
          <van-field :label="getLabel('trueName')" v-model="player.trueName" placeholder="请输入名称"
            :rules="[rulesWay('请输入名称'), { validator: regexName, message: '姓名只能为汉字或字母' }]"></van-field>
          <van-field v-if="playerCheckboxes.IDCard" label="证件类型" v-model="player.certTypeValue" placeholder="请选择证件类型"
            readonly clickable @click="showCertTypeFun" :rules="[rulesWay('请选择证件类型')]"></van-field>
          <van-field v-if="playerCheckboxes.IDCard" label="证件号码" v-model="player.IDCardNo" placeholder="请输入证件号码"
            :rules="[rulesWay('请输入证件号码'), { validator: checkIDCardNo, message: '请输入正确的证件号码' }]"></van-field>
          <van-field v-if="playerCheckboxes.mobile" label="联系电话" v-model="player.mobile" placeholder="请输入联系电话"
            :rules="[rulesWay('请输入联系电话'), { validator: checkMobile, message: '请输入正确的联系电话' }]"></van-field>
          <van-field v-if="playerCheckboxes.gender" label="性别" v-model="player.gender" :rules="[rulesWay('请选择性别')]">
            <template #input>
              <van-radio-group v-model="player.gender" direction="horizontal">
                <van-radio name="1" checked-color="#FF6010" icon-size="16px"
                  :disabled="checkIDCardNoDis(player.IDCardNo)">男</van-radio>
                <van-radio name="2" checked-color="#FF6010" icon-size="16px"
                  :disabled="checkIDCardNoDis(player.IDCardNo)">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.bmBirthday" :label="getLabel('bmBirthday')" v-model="player.bmBirthdayValue"
            placeholder="请选择出生年月" readonly clickable @click="showBirthdayFun" :rules="[rulesWay('请选择出生年月')]"></van-field>
          <van-field v-if="playerCheckboxes.avatar" label="报名照" :rules="[rulesWay('请上传报名照')]">
            <template #input>
              <van-uploader v-model="player.avatarList" max-count="1" :after-read="uploadAvatar" @delete="deleteAvatar" />
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.nationality" label="国籍" v-model="player.nationality" placeholder="请输入国籍"
            :rules="[rulesWay('请输入国籍')]"></van-field>
          <van-field v-if="playerCheckboxes.IDCardPhotoA" label="身份证/护照正面" :rules="[rulesWay('请上传身份证/护照正面')]">
            <template #input>
              <van-uploader v-model="player.IDCardPhotoAList" max-count="1" :after-read="uploadIDCardPhotoA"
                @delete="deleteIDCardPhotoA" />
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.IDCardPhotoB" label="身份证/护照背面" :rules="[rulesWay('请上传身份证/护照背面')]">
            <template #input>
              <van-uploader v-model="player.IDCardPhotoBList" max-count="1" :after-read="uploadIDCardPhotoB"
                @delete="deleteIDCardPhotoB" />
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.number" type="digit" label="球衣号码" v-model="player.number"
            placeholder="请输入球衣号码"
            :rules="[rulesWay('请输入球衣号码'), { validator: regexNumber, message: '只能输入0-99数字' }]"></van-field>

          <van-field v-if="playerCheckboxes.position && match.sportType !== '足球'" label="场上位置" v-model="player.position"
            placeholder="请输入场上位置" :rules="[rulesWay('请输入场上位置')]"></van-field>
          <van-field v-else-if="playerCheckboxes.position" label="场上位置" v-model="player.position" placeholder="请选择场上位置"
            readonly clickable @click="showSite = true" :rules="[rulesWay('请选择场上位置')]"></van-field>

          <van-field v-if="playerCheckboxes.emergencyContactName" label="紧急联系人" v-model="player.emergencyContactName"
            placeholder="请输入紧急联系人"
            :rules="[rulesWay('请输入紧急联系人'), { validator: regexName, message: '联系人姓名只能为汉字或字母' }]"></van-field>
          <van-field v-if="playerCheckboxes.isProfessionalPlayer" label="是否职业球员" v-model="player.isProfessionalPlayer"
            :rules="[rulesWay('请选择是否是职业球员')]">
            <template #input>
              <van-radio-group v-model="player.isProfessionalPlayer" direction="horizontal">
                <van-radio name="0" checked-color="#FF6010" icon-size="16px">否</van-radio>
                <van-radio name="1" checked-color="#FF6010" icon-size="16px">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.high" type="digit" label="身高" v-model="player.high" placeholder="请输入身高（CM）"
            :rules="[rulesWay('请输入身高（CM）'), { validator: regexHigh, message: '只能输入0-250数字' }]"></van-field>
          <van-field v-if="playerCheckboxes.weight" type="digit" label="体重" v-model="player.weight"
            placeholder="请输入体重（KG）"
            :rules="[rulesWay('请输入体重（KG）'), { validator: regexWeight, message: '只能输入0-200数字' }]"></van-field>
          <van-field v-if="playerCheckboxes.bmEmail" label="邮箱地址" v-model="player.bmEmail" placeholder="请输入邮箱地址"
            :rules="[rulesWay('请输入邮箱地址'), { validator: isEmail, message: '请输入邮箱地址' }]"></van-field>
          <van-field v-if="playerCheckboxes.jerseyName" label="球衣姓名" v-model="player.jerseyName" placeholder="请输入球衣姓名"
            :rules="[rulesWay('请输入球衣姓名'), { validator: regexTeamName, message: '球衣姓名最多输入20个字符' }]"></van-field>
          <!-- <van-field v-if="playerCheckboxes.jerseysSize" label="球衣尺码" v-model="player.jerseysSize" placeholder="请输入球衣尺码"
            :rules="[rulesWay('请输入球衣尺码')]"></van-field> -->
          <JerseySize v-if="playerCheckboxes.jerseysSize" :card="jerseysSizeObj.card" :arr="jerseysSizeObj.arr"
            :text="player.jerseysSize" @update="(e) => player.jerseysSize = e" />
          <van-field v-if="playerCheckboxes.shoesSize" type="digit" label="球鞋尺码" v-model="player.shoesSize"
            placeholder="请输入球鞋尺码"
            :rules="[rulesWay('请输入球鞋尺码'), { validator: regexShoesSize, message: '只能输入20-50数字' }]"></van-field>
          <van-field v-if="playerCheckboxes.qualificationFile" input-align="left" label="资质证明"
            :rules="[rulesWay('请上传资质证明')]" style="display: block;">
            <template #input>
              <div class="my-imgs">
                <div style="font-size: 12px;margin-bottom: 6px;">最多上传5张图片</div>
                <div style="padding-left: 12px;">
                  <van-uploader v-model="player.qualificationFileList" max-count="5" :after-read="uploadQualificationFile"
                    @delete="deleteQualificationFile" />
                </div>
              </div>
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.insureFile" label="保险证明" :rules="[rulesWay('请上传保险证明')]">
            <template #input>
              <van-uploader v-model="player.insureFileList" max-count="1" :after-read="uploadInsureFile"
                @delete="deleteInsureFile" />
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.school" label="就读学校" v-model="player.school" placeholder="请输入就读学校"
            :rules="[rulesWay('请输入就读学校')]"></van-field>
          <van-field v-if="playerCheckboxes.remark" label="备注" v-model="player.remark" placeholder="请输入备注"
            :rules="[rulesWay('请输入备注')]"></van-field>
          <van-field v-if="playerCheckboxes.domicileAreaId" label="所属城市" v-model="player.domicileAreaName" readonly
            @click="showArea = true" placeholder="请选择所属城市" :rules="[rulesWay('请选择所属城市')]"></van-field>
          <van-field v-if="playerCheckboxes.ethnicity" label="民族" v-model="player.ethnicity" placeholder="请输入民族"
            :rules="[rulesWay('请输入民族')]"></van-field>
          <van-field v-if="playerCheckboxes.title" label="队内职务" v-model="player.title" placeholder="请输入队内职务"
            :rules="[rulesWay('请输入队内职务')]"></van-field>
          <van-field v-if="playerCheckboxes.enterprise" label="工作单位" v-model="player.enterprise" placeholder="请输入工作单位"
            :rules="[rulesWay('请输入工作单位')]"></van-field>
          <van-field v-if="playerCheckboxes.post" label="岗位" v-model="player.post" placeholder="请输入岗位"
            :rules="[rulesWay('请输入岗位')]"></van-field>
          <van-field v-if="playerCheckboxes.guardianName" label="家长姓名" v-model="player.guardianName" placeholder="请输入家长姓名"
            :rules="[rulesWay('请输入家长姓名'), { validator: regexName, message: '家长姓名只能为汉字或字母' }]"></van-field>
          <van-field v-if="playerCheckboxes.guardianMobile" label="家长手机号" v-model="player.guardianMobile"
            placeholder="请输入家长手机号"
            :rules="[rulesWay('请输入家长手机号'), { validator: checkMobile, message: '手机号格式不正确' }]"></van-field>
          <van-field v-if="playerCheckboxes.joinTeam" label="所属球队" v-model="player.joinTeam" placeholder="请输入所属球队"
            :rules="[rulesWay('请输入所属球队')]"></van-field>
          <van-field v-if="playerCheckboxes.serialNumber" :label="getLabel('serialNumber')" v-model="player.serialNumber"
            placeholder="请输入中国足协信息化平台球员编码"></van-field>
        </van-form>
        <div style="height: 80px;"></div>
        <div class="bottom" v-if="showButton">
          <van-button type="info" round block @click="savePlayer" style="height: 50px; background-color: #191919;">
            <span style="color: #FFFFFF;">保 存</span>
          </van-button>
        </div>
      </van-popup>
      <van-popup v-model="showOfficer" position="bottom" :style="{ height: '70%' }" round>
        <van-form ref="officerForm" input-align="right" error-message-align="right">
          <div
            style="padding: 12px 0; font-size: 18px; color: #191919; text-align: center; border-bottom: 1px #EEEEEE solid">
            工作人员添加/编辑</div>
          <van-field label="姓名" v-model="officer.name" placeholder="请输入姓名" :rules="[rulesWay('请输入名称')]"></van-field>
          <van-field label="照片" :rules="[rulesWay('照片不能为空')]">
            <template #input>
              <van-uploader v-model="officer.avatarList" max-count="1" :after-read="uploadAvatar2"
                @delete="deleteAvatar2" />
            </template>
          </van-field>
          <van-field v-if="teamOfficersCertRequired === 1" label="证件号码" v-model="officer.certNo" placeholder="请输入身份证号码"
            :rules="[rulesWay('请输入身份证号码'), { validator: checkIDCardNoDis, message: '请输入正确的证件号码' }]"></van-field>
          <van-field label="性别" v-model="officer.gender" :rules="[rulesWay('请选择性别')]">
            <template #input>
              <van-radio-group v-model="officer.gender" direction="horizontal">
                <van-radio :disabled="checkIDCardNoDis(officer.certNo)" name="1" checked-color="#FF6010"
                  icon-size="16px">男</van-radio>
                <van-radio :disabled="checkIDCardNoDis(officer.certNo)" name="2" checked-color="#FF6010"
                  icon-size="16px">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field label="职务" v-model="officer.role" placeholder="请选择职务" readonly clickable @click="showRolesFun"
            :rules="[rulesWay('请选择职务')]"></van-field>
          <van-field label="联系方式" v-model="officer.mobile" placeholder="请输入联系方式" :rules="[rulesWay('请输入联系方式'),
          { validator: checkMobile, message: '手机号格式不正确' }]"></van-field>
          <van-field v-if="match.sportType === '足球' && (officer.role === '教练' || officer.role === '主教练')" label="证书等级"
            v-model="officer.certificateTypeText" placeholder="请选择证书等级" readonly clickable @click="showClass = true"
            :rules="[rulesWay('请选择证书等级')]"></van-field>
        </van-form>
        <div style="height: 80px;"></div>
        <div class="bottom" v-if="showButton">
          <van-button type="info" round block @click="saveOfficer" style="height: 50px; background-color: #191919;">
            <span style="color: #FFFFFF;">保 存</span>
          </van-button>
        </div>
      </van-popup>
      <van-popup v-model="showBirthday" position="bottom" :style="{ height: '50%' }">
        <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
          @cancel="cancelBirthdayTime" @confirm="confirmBirthdayTime" />
      </van-popup>
      <van-popup v-model="showRoles" position="bottom" :style="{ height: '50%' }">
        <van-picker title="请选择角色" show-toolbar :columns="roleColumns" @confirm="onConfirm" @cancel="onCancel"
          :default-index="defaultIndex" />
      </van-popup>
      <van-popup v-model="showCertType" position="bottom" :style="{ height: '50%' }">
        <van-picker title="请选择证件类型" show-toolbar :columns="certTypeColumns" value-key="label" @confirm="onConfirmCertType"
          @cancel="onCancelCertType" :default-index="defaultCertIndex" />
      </van-popup>
      <van-popup v-model="showNationality" position="bottom" :style="{ height: '50%' }">
        <van-picker title="请选择国籍" show-toolbar :columns="nationalityColumns" @confirm="onConfirmNationality"
          @cancel="onCancelNationality" :default-index="defaultNationalityIndex" />
      </van-popup>
      <van-popup v-model="showHomeColor" position="bottom" :style="{ height: '50%' }">
        <van-picker title="请选择主队服颜色" show-toolbar :columns="clothesColor" @confirm="onConfirmHomeColor"
          @cancel="onCancelHomeColor">
          <template #option="option">
            <div style="display: flex; align-items: center">
              <img :src="option.img" style="width: 24px; height: 24px; margin-right: 12px" />
              <span>{{ option.label }}</span>
            </div>
          </template>
        </van-picker>
      </van-popup>
      <van-popup v-model="showAwayColor" position="bottom" :style="{ height: '50%' }">
        <van-picker title="请选择客队服颜色" show-toolbar :columns="clothesColor" @confirm="onConfirmAwayColor"
          @cancel="onCancelAwayColor">
          <template #option="option">
            <div style="display: flex; align-items: center">
              <img :src="option.img" style="width: 24px; height: 24px; margin-right: 12px" />
              <span>{{ option.label }}</span>
            </div>
          </template>
        </van-picker>
      </van-popup>
      <van-popup v-model="showArea" round position="bottom">
        <van-cascader v-model="player.domicileAreaId" title="请选择所在地区" :options="options" :field-names="fieldNames"
          @close="showArea = false" @change="onChange" @finish="onFinish" />
      </van-popup>
      <van-popup v-model="showClass" round position="bottom" :style="{ height: '50%' }">
        <van-cascader :options="optionsClass" @close="showClass = false" v-model="certificateTypeText"
          @finish="finishClass" />
      </van-popup>
      <van-popup v-model="showSite" round position="bottom" :style="{ height: '50%' }">
        <van-picker title="请选择位置" show-toolbar :columns="siteList"
          @confirm="(e) => { player.position = e, showSite = false }" @cancel="showSite = false" />
      </van-popup>
    </div>
    <van-overlay :show="showLoading">
      <div class="wrapper">
        <van-loading color="#1989fa" size="30" />
      </div>
    </van-overlay>
    <ShareLayer :shareShow="shareShow" @close="shareShow = false"></ShareLayer>
    <van-dialog v-model="showDialog" title="报名提交成功" @confirm="continueFinish" confirm-button-text="继续完善"
      theme="round-button" confirm-button-color="darkblue">
      <div style="font-size: 13px; color: #333333; padding: 12px 20px 10px 20px">
        <span style="display: inline-block; font-size: 13px; width: 2em;"></span>报名提交成功，您可以前往"<span @click="goEntryList"
          style="color: #0065FF; text-decoration-line: underline">我的参赛</span>"列表查看报名进度，也可以留下继续完善报名
      </div>
    </van-dialog>
    <van-popup v-model="showDelegation" position="bottom" :style="{ height: '50%' }">
      <van-picker title="代表团" show-toolbar :columns="delegationList" @confirm="onConfirm2"
        @cancel="showDelegation = false" />
    </van-popup>
    <van-popup v-model="signupInstructionsOpen" :close-on-click-overlay="false"
      :style="{ width: '80%', 'border-radius': '4px' }">
      <div class="notice">
        <div class="notice-title">报名须知</div>
        <div class="info" v-html="signupInstructions"></div>
        <div class="close" :class="{ 'disabled': time > 0 }" @click="closeNotice">
          我知道了 <span v-if="time > 0">({{ time }})</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Tab, Tabs, Form, Field, Icon, Popup, Cascader,
  Checkbox, Loading, Overlay, Dialog, Uploader,
  Toast, RadioGroup, Radio, DatetimePicker, SwipeCell, Button, Picker, Image as VanImage, ImagePreview
} from "vant";
import { DateUtil, QNImageUtil, RegExpr, ToolUtil, isWeChatMiniApp } from '@/utils'
import { getQiniuUploadToken, uploadImage } from '@/api/qiniu'
import {
  bangsaishiCreatePlayerSignupOrder,
  createBMMatchTeam,
  createBMMatchTeamOffice,
  createBMMatchTeamPlayer,
  deleteBMMatchTeamOffice, deleteBMMatchTeamPlayer, getAreaTreeList,
  getBMMatchTeamSignup,
  getBMUnionMatch,
  updateBMMatchTeam,
  updateBMMatchTeamOffice,
  updateBMMatchTeamPlayer
} from "@/api/match";
import Cookies from 'js-cookie'
// import {getWeChatSignature} from "@/api/wechat";
// import { shareWeChat} from "@/libs/wechat-share";
// import { ConstConfig } from "@/constants";
import ShareLayer from "@/components/ShareLayer"
import JerseySize from '@/components/JerseySize'
import { getPassport } from "@/libs/passport";
import wx from 'weixin-js-sdk'
import { AppType } from '@/constants/appType'
Vue.use(Tab).use(Tabs).use(Form).use(Field).use(Icon).use(Popup).use(Checkbox)
  .use(Loading).use(Overlay).use(Dialog).use(Uploader).use(RadioGroup).use(Radio).use(Button)
  .use(DatetimePicker).use(SwipeCell).use(Picker).use(Cascader).use(VanImage).use(ImagePreview)
import { feeMethodOptions, orderStatusOptions } from '@/config'

// const roleColumns = ['领队', '主教练', '教练', '队医', '队务']

const certTypeColumns = ['身份证', '学籍卡', '护照', '港澳通行证', '台胞证', '港澳台回乡证']

const clothesColor = [
  { value: '1', label: '白色', img: require('../../../assets/jersey-color/qy_1.png') },
  { value: '2', label: '蓝色', img: require('../../../assets/jersey-color/qy_2.png') },
  { value: '3', label: '暗红', img: require('../../../assets/jersey-color/qy_3.png') },
  { value: '4', label: '深黄', img: require('../../../assets/jersey-color/qy_4.png') },
  { value: '5', label: '绿色', img: require('../../../assets/jersey-color/qy_5.png') },
  { value: '6', label: '紫色', img: require('../../../assets/jersey-color/qy_6.png') },
  { value: '7', label: '橙色', img: require('../../../assets/jersey-color/qy_7.png') },
  { value: '8', label: '黑色', img: require('../../../assets/jersey-color/qy_8.png') },
  { value: '9', label: '白底黑条纹', img: require('../../../assets/jersey-color/qy_9.png') },
  { value: '10', label: '紫底黑条纹', img: require('../../../assets/jersey-color/qy_10.png') },
  { value: '11', label: '白底红条纹', img: require('../../../assets/jersey-color/qy_11.png') },
  { value: '12', label: '红底黑条纹', img: require('../../../assets/jersey-color/qy_12.png') },
  { value: '13', label: '黄底红条纹', img: require('../../../assets/jersey-color/qy_13.png') },
  { value: '14', label: '红底紫条纹', img: require('../../../assets/jersey-color/qy_14.png') },
  { value: '15', label: '白底蓝条纹', img: require('../../../assets/jersey-color/qy_15.png') },
  { value: '16', label: '黄底绿条纹', img: require('../../../assets/jersey-color/qy_16.png') },
  { value: '17', label: '白底黑条纹（竖）', img: require('../../../assets/jersey-color/qy_17.png') },
  { value: '18', label: '白底红条纹（竖）', img: require('../../../assets/jersey-color/qy_18.png') },
  { value: '19', label: '白底黄条纹（竖）', img: require('../../../assets/jersey-color/qy_19.png') },
  { value: '20', label: '白底蓝条纹（竖）', img: require('../../../assets/jersey-color/qy_20.png') },
  { value: '21', label: '红底黑条纹（竖）', img: require('../../../assets/jersey-color/qy_21.png') },
  { value: '22', label: '红底紫条纹（竖）', img: require('../../../assets/jersey-color/qy_22.png') },
  { value: '23', label: '黄底黑条纹（竖）', img: require('../../../assets/jersey-color/qy_23.png') },
  { value: '24', label: '黄底绿条纹（竖）', img: require('../../../assets/jersey-color/qy_24.png') },
  { value: '25', label: '粉红', img: require('../../../assets/jersey-color/qy_25.png') },
  { value: '26', label: '天蓝', img: require('../../../assets/jersey-color/qy_26.png') },
  { value: '27', label: '浅黄', img: require('../../../assets/jersey-color/qy_27.png') }
]

const certTypeOption = [
  { value: 1, label: '身份证' },
  { value: 11, label: '学籍卡' },
  { value: 2, label: '护照' },
  { value: 3, label: '港澳通行证' },
  { value: 4, label: '台胞证' },
  { value: 5, label: '港澳台回乡证' }
]

const nationalityOption = [
  { value: 1, label: '中国' }
]

const defaultTeam = {
  name: '',
  contactPerson: '',
  contactNumber: '',
  badge: '',
  badgeList: [],
  summary: '',
  homeClothesColor: '',
  awayClothesColor: '',
  delegation: '',
  insurancePolicy: '',
  insurancePolicyList: []
}

export default {
  components: {
    ShareLayer,
    JerseySize
  },
  data() {
    return {
      clothes: [],
      nationalityColumns: ['中国'],
      certTypeColumns: certTypeOption,
      roleColumns: [],
      clothesColor: clothesColor,
      showHomeColor: false,
      showAwayColor: false,
      unionMatchId: '',
      match: {},
      projectId: '',
      teamId: '',
      project: {},
      active: 'team',
      team: {},
      players: [],
      player: {},
      officers: [],
      officer: {},
      index: '',
      type: '',
      showPlayer: false,
      showOfficer: false,
      allow: false,
      showLoading: false,
      showDialog: false,
      qiniuToken: '',
      showBirthday: false,
      minDate: '',
      maxDate: '',
      currentDate: '',
      showRoles: false,
      defaultIndex: 0,
      showCertType: false,
      defaultCertIndex: 0,
      showNationality: false,
      defaultNationalityIndex: 0,
      shareShow: false,
      options: [],
      fieldNames: {
        text: 'name',
        value: 'id',
        children: 'kids',
      },
      showArea: false,
      teamCheckboxes: {},
      playerCheckboxes: {},
      genderOld: '',
      teamColor: {
        home: {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: ''
        },
        away: {
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          f: ''
        }
      },
      showClass: false,
      certificateTypeText: [],
      optionsClass: [
        {
          text: '十一人制足球教练员',
          value: 1,
          children: [
            { text: 'E级', value: 1 },
            { text: 'D级', value: 2 },
            { text: 'C级', value: 3 },
            { text: 'B级', value: 4 },
            { text: 'A级', value: 5 },
            { text: '职业级(PRO)', value: 6 },
          ],
        },
        {
          text: '五人制足球教练员',
          value: 2,
          children: [
            { text: '初级', value: 7 },
            { text: 'L1', value: 8 },
            { text: 'L2', value: 9 },
            { text: 'L3', value: 10 },
            { text: '职业级(PRO)', value: 11 },
          ]
        },
        {
          text: '社体指导员(足球)',
          value: 3,
          children: [
            { text: '5级(初级)', value: 12 },
            { text: '4级(中级)', value: 13 },
            { text: '3级(高级)', value: 14 },
            { text: '2级(指导师)', value: 15 },
          ]
        }
      ],
      showSite: false,
      siteList: ['前锋', '中场', '后卫', '门将'],
      jerseysSizeObj: {},
      showButton: false,
      showDelegation: false,
      delegationList: [],
      signupInstructionsOpen: false,
      time: 5,
      signupInstructions: '',
      teamOfficersCertRequired: 0,
      playerSignupFieldsLabel: {
        trueName: '姓名',
        bmBirthday: '出生日期',
        serialNumber: '注册证号'
      },
      teamSignupFieldsLabel: {
        insurancePolicy: '参赛资料'
      }
    }
  },
  watch: {
    'player.IDCardNo': {
      handler() {
        if (RegExpr.isIdCard(this.player.IDCardNo)) {
          const player = JSON.parse(JSON.stringify(this.player))
          player.gender = '' + ToolUtil.getSex(player.IDCardNo)
          player.bmBirthdayValue = ToolUtil.getBirthday(player.IDCardNo)
          player.bmBirthday = DateUtil.parseDateTime(ToolUtil.getBirthday(this.player.IDCardNo), '{y}-{m}-{d}T00:00:00+0800')
          this.player = player
        }
      }
    },
    'player.gender': {
      handler() {
        if (this.playerCheckboxes.gender && (this.project.genderLimit != 0 && this.project.genderLimit != 3) && this.player.gender != this.project.genderLimit) {
          Toast({ type: 'fail', message: '性别异常' })
        }
      }
    },
    'officer.certNo': {
      handler() {
        if (RegExpr.isIdCard(this.officer.certNo)) {
          const officer = JSON.parse(JSON.stringify(this.officer))
          officer.gender = '' + ToolUtil.getSex(officer.certNo)
          this.officer = officer
        }
      }
    }
  },
  mounted() {
    getPassport().then(res => {
      if (res) {
        this.unionMatchId = this.$route.query.unionMatchId
        this.projectId = this.$route.query.matchId
        this.teamId = this.$route.query.teamId || ''
        if (this.teamId !== '') {
          this.$nextTick(() => {
            this.active = 'player'
          })
        }
        this.getBMUnionMatch()
        this.getQiniuUploadToken()
      }
    })
  },
  methods: {
    getLabel(type) {
      const label = this.playerSignupFieldsLabel[type]
      return label
    },
    closeNotice() {
      if (this.time <= 0) {
        this.signupInstructionsOpen = false
        Cookies.set(this.projectId, this.projectId)
      }
    },
    uploadFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      const type = file.file.type.split('/')[1]
      uploadImage(formData).then(res => {
        const hash = res.hash + ',' + type
        this.team.insurancePolicy = hash
        this.$forceUpdate()
      })
    },
    deleteFile() {
      const team = JSON.parse(JSON.stringify(this.team))
      team.insurancePolicy = ''
      team.insurancePolicyList = []
      this.team = team
    },
    onConfirm2(e) {
      this.team.delegation = e
      this.showDelegation = false
    },
    regexNumber(value) {
      return value >= 0 && value <= 99
    },
    regexShoesSize(value) {
      return value >= 20 && value <= 50
    },
    regexHigh(value) {
      return value >= 0 && value <= 250
    },
    regexWeight(value) {
      return value >= 0 && value <= 200
    },
    isEmail(value) {
      return RegExpr.isEmail(value)
    },
    regexName(value) {
      let regex = /^[A-Za-z\u4e00-\u9fa5\s]+$/
      return regex.test(value) || true
    },
    regexTeamName(value) {
      const length = this.strLength(value)
      return length <= 20
    },
    strLength(word) {
      let length = 0
      if (typeof word === 'number') {
        length = word.toString().length
      } else if (word === null) {
        length = 3
      } else if (typeof word === 'undefined') {
        length = 0
      } else {
        Array.from(word).map(function (char) {
          if (char.charCodeAt(0) > 255) {
            //字符编码大于255，说明是双字节字符
            length += 2
          } else {
            length++
          }
        })
      }
      return length
    },
    finishClass({ selectedOptions }) {
      this.officer.certificateTypeText = `${selectedOptions[0].text}/${selectedOptions[1].text}`
      this.officer.certificateType = selectedOptions[0].value
      this.officer.certificateLevel = selectedOptions[1].value
      this.showClass = false
    },
    doPay(item) {
      const params = {
        matchId: this.projectId,
        teamId: this.teamId,
        playerId: item.id
      }
      bangsaishiCreatePlayerSignupOrder(params).then(res => {
        if (res) {
          localStorage.setItem('saas-redirect', window.location.href)
          this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=1&teamId=${this.teamId}&matchId=${this.projectId}&playerId=${item.id}`)
        }
      })
    },
    rulesWay(message) {
      return { required: true, message }
    },
    checkIDCardNoDis(value) {
      return RegExpr.isIdCard(value)
    },
    showBirthdayFun() {
      if (RegExpr.isIdCard(this.player.IDCardNo)) return
      this.showBirthday = true
    },
    previewImg(img) {
      if (!img) return
      ImagePreview([
        this.imageView((this.getClothesImg(img)))
      ])
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getClothesImg(id) {
      const c = this.clothes.find(item => item.id === id)
      if (!c) return ''
      return c.image
    },
    chooseClothes(item) {
      // if (item.isChoosed === 1) return
      this.$set(this.team, 'clothesId', item.id)
    },
    getPaymentStatus(value) {
      if (this.project.isOpenCharge !== 1) return ''
      if (this.project.feeMethod === 0) return ''
      const order = orderStatusOptions.find(o => o.value === value)
      if (!order) return '待支付'
      return order.label
    },
    getFeeMethodsLabel(value) {
      const item = feeMethodOptions.find(f => f.value === value)
      if (!item) return '--'
      return item.label
    },
    getCertTypeObj(value) {
      const obj = certTypeOption.find(i => i.value === value)
      if (obj) {
        return obj
      } else {
        return certTypeOption[0]
      }
    },
    onChange({ selectedOptions }) {
      const a = []
      selectedOptions.forEach(item => {
        a.push(item.name)
      })
      this.player.domicileAreaName = a.join('/')
    },
    onFinish({ selectedOptions }) {
      const a = []
      selectedOptions.forEach(item => {
        a.push(item.name)
      })
      this.player.domicileAreaName = a.join('/')
      this.showArea = false
    },
    getAreaTreeList() {
      getAreaTreeList().then(res => {
        if (res) {
          const { data } = res
          this.options = JSON.parse(data.list.list.replaceAll("'", '"')) || []
          this.getBMMatchTeamSignup()
        }
      })
    },
    getPlayers() {
      const params = {
        matchId: this.projectId
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          this.players = data.players || []
        }
      })
    },
    getOfficers() {
      const params = {
        matchId: this.projectId
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          this.officers = data.officers || []
        }
      })
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.projectId,
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          const project = data.match
          this.minDate = this.project.maxAge ? new Date(this.project.maxAge) : new Date(1970, 0, 1)
          this.maxDate = this.project.minAge ? new Date(this.project.minAge) : new Date()
          const psfs = project.playerSignupFields && project.playerSignupFields.split('|') || []
          this.jerseysSizeObj = {
            card: project.jerseysSizeAccessory,
            arr: project.jerseysSizeFields.split(',')
          }
          if (project.playerSignupFieldsLabel) {
            this.playerSignupFieldsLabel = {
              ...this.playerSignupFieldsLabel,
              ...project.playerSignupFieldsLabel,
            }
          }
          if (project.teamSignupFieldsLabel) {
            this.teamSignupFieldsLabel = {
              ...this.teamSignupFieldsLabel,
              ...project.teamSignupFieldsLabel,
            }
          }
          const playerCheckboxes = {}
          psfs.forEach(psf => {
            playerCheckboxes[psf] = true
          })
          this.playerCheckboxes = playerCheckboxes
          const tsfs = project.teamSignupFields && project.teamSignupFields.split('|') || []
          const teamCheckboxes = {}
          tsfs.forEach(tsf => {
            teamCheckboxes[tsf] = true
          })
          this.teamCheckboxes = teamCheckboxes
          if (this.teamCheckboxes.clothesColorDescription && data.team.clothesColorDescription) {
            const clothesColorDescription = data.team.clothesColorDescription.split(',')
            const home = {
              a: clothesColorDescription[0].split(':')[1].trim(),
              b: clothesColorDescription[1].split(':')[1].trim(),
              c: clothesColorDescription[2].split(':')[1].trim(),
              d: clothesColorDescription[6].split(':')[1].trim(),
              e: clothesColorDescription[7].split(':')[1].trim(),
              f: clothesColorDescription[8].split(':')[1].trim(),
            }
            const away = {
              a: clothesColorDescription[3].split(':')[1].trim(),
              b: clothesColorDescription[4].split(':')[1].trim(),
              c: clothesColorDescription[5].split(':')[1].trim(),
              d: clothesColorDescription[9].split(':')[1].trim(),
              e: clothesColorDescription[10].split(':')[1].trim(),
              f: clothesColorDescription[11].split(':')[1].trim(),
            }
            this.teamColor = { home, away }
          }
          this.teamOfficersCertRequired = project.teamOfficersCertRequired
          this.project = data.match
          this.players = data.players || []
          this.officers = data.officers || []
          this.team = data.team || JSON.parse(JSON.stringify(defaultTeam))
          this.showButton = data.team.auditStatus != 2 && (data.team.isSubmit === 0 || data.team.auditStatus === -1)
          this.team.badgeList = this.team.badge && [{ url: QNImageUtil.imageView(this.team.badge), isImage: true }] || []
          this.team.insurancePolicyList = this.team.insurancePolicy && [{ url: QNImageUtil.imageView(this.team.insurancePolicy) }] || []
          this.team.homeClothesColorImg = this.findImg(this.team.homeClothesColor)
          this.team.awayClothesColorImg = this.findImg(this.team.awayClothesColor)
          const clothes = data.clothes
          if (this.team.clothesId) {
            clothes.forEach(c => {
              if (c.id === this.team.clothesId) c.isChoosed = 0
            })
          }
          if (data.match.teamDelegations) {
            this.delegationList = data.match.teamDelegations.split(',') || []
          }
          this.certTypeColumns = this.certTypeColumns.filter(item => project.certTypeFields.indexOf(item.value) > -1) // 动态证件类型
          this.clothes = clothes
          if (project.teamOfficers) {
            this.roleColumns = project.teamOfficers.split(',') || []
          }
          if (project.signupInstructionsOpen === 1 && Cookies.get(this.projectId) != this.projectId) {
            this.signupInstructions = project.signupInstructions
            this.signupInstructionsOpen = true
            let time = setInterval(() => {
              this.time--;
              if (this.time === 0) {
                clearInterval(time)
              }
            }, 1000);
          }
          this.setWXShare()
        }
      })
    },
    findImg(colorIndex) {
      const clothes = clothesColor.find(item => item.value === colorIndex)
      if (clothes) {
        return clothes.img
      } else {
        return ''
      }
    },
    getBMUnionMatch() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
          this.getAreaTreeList()
        }
      })
    },
    showHomeColorFun() {
      this.showHomeColor = true
    },
    showAwayColorFun() {
      this.showAwayColor = true
    },
    getAge(birthday) {
      if (!birthday) return ''
      const now = new Date()
      const b = new Date(birthday)
      let age = now.getFullYear() - b.getFullYear()
      if (now.getMonth() < b.getMonth()) {
        age--
      } else if (now.getMonth() === b.getMonth() && now.getDate() < b.getDate) {
        age--
      }
      return `(${age}岁)`
    },
    confirmBirthdayTime(value) {
      this.player.bmBirthdayValue = DateUtil.parseDateTime(value, '{y}-{m}-{d}')
      this.player.bmBirthday = DateUtil.parseDateTime(value, '{y}-{m}-{d}T00:00:00+0800')
      this.showBirthday = false
    },
    cancelBirthdayTime() {
      this.showBirthday = false
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    uploadBadge(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.team.badge = res.hash
        this.$forceUpdate()
      })
    },
    uploadAvatar2(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.officer.avatar = res.hash
        this.$forceUpdate()
      })
    },
    deleteAvatar2() {
      console.log(1111);
      console.log(this.officer);
      this.officer.avatar = ''
      this.$set(this.officer, 'avatarList', [])
      // this.officer.avatarList = []
      // console.log(this.officer);
    },
    deleteBadge() {
      const team = JSON.parse(JSON.stringify(this.team))
      team.badge = ''
      team.badgeList = []
      this.team = team
    },
    uploadAvatar(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.avatar = res.hash
      })
    },
    deleteAvatar() {
      const player = JSON.parse(JSON.stringify(this.player))
      player.avatar = ''
      player.avatarList = []
      this.player = player
    },
    uploadQualificationFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.player))
        if (player.qualificationFile && player.qualificationFile.length > 0) {
          player.qualificationFile = player.qualificationFile + ',' + res.hash
        } else {
          player.qualificationFile = res.hash
        }
        const a = player.qualificationFile.split(',')
        player.qualificationFileList = []
        a.forEach(item => {
          player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item },)
        })
        this.player = player
      })
    },
    deleteQualificationFile() {
      const player = JSON.parse(JSON.stringify(this.player))
      const a = []
      player.qualificationFileList.forEach(item => {
        a.push(item.hash)
      })
      player.qualificationFile = a.join(',')
      this.player = player
    },
    uploadInsureFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.player))
        if (player.insureFile && player.insureFile.length > 0) {
          player.insureFile = player.insureFile + ',' + res.hash
        } else {
          player.insureFile = res.hash
        }
        const a = player.insureFile.split(',') || []
        player.insureFileList = []
        a.forEach(item => {
          player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item },)
        })
        this.player = player
      })
    },
    deleteInsureFile() {
      const player = JSON.parse(JSON.stringify(this.player))
      const a = []
      player.insureFileList.forEach(item => {
        a.push(item.hash)
      })
      player.insureFile = a.join(',')
      this.player = player
    },
    uploadIDCardPhotoA(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.IDCardPhotoA = res.hash
      })
    },
    deleteIDCardPhotoA() {
      const player = JSON.parse(JSON.stringify(this.player))
      player.IDCardPhotoA = ''
      player.IDCardPhotoAList = []
      this.player = player
    },
    uploadIDCardPhotoB(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.IDCardPhotoB = res.hash
      })
    },
    deleteIDCardPhotoB() {
      const player = JSON.parse(JSON.stringify(this.player))
      player.IDCardPhotoB = ''
      player.IDCardPhotoBList = []
      this.player = player
    },
    checkMobile(value) {
      return RegExpr.checkMobile(value)
    },
    checkIDCardNo(value) {
      if (this.player.certType === 1) return RegExpr.isIdCard(value)
      return true
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    createTeam() {
      if (!this.allow) {
        Toast.fail('请先同意章程')
        return
      }
      this.$refs.teamForm.validate().then(() => {
        this.showLoading = true
        const params = JSON.parse(JSON.stringify(this.team))
        delete params.badgeList
        if (this.teamCheckboxes.clothesColorDescription) {
          const home = this.teamColor.home
          const away = this.teamColor.away
          params.clothesColorDescription = `主场上衣:${home.a},主场短裤:${home.b},主场球袜:${home.c},客场上衣:${away.a},客场短裤:${away.b},客场球袜:${away.c},主场守门员上衣:${home.d},主场守门员短裤:${home.e},主场守门员球袜:${home.f},客场守门员上衣:${away.d},客场守门员短裤:${away.e},客场守门员球袜:${away.f}`
        }
        params.matchId = this.projectId
        createBMMatchTeam(params).then(res => {
          if (res) {
            this.teamId = res.data.id
            this.showLoading = false
            this.showDialog = true
          } else {
            this.showLoading = false
          }
        })
      })
    },
    updateTeam() {
      this.$refs.teamForm.validate().then(() => {
        const params = JSON.parse(JSON.stringify(this.team))
        delete params.badgeList
        if (this.teamCheckboxes.clothesColorDescription) {
          const home = this.teamColor.home
          const away = this.teamColor.away
          params.clothesColorDescription = `主场上衣:${home.a},主场短裤:${home.b},主场球袜:${home.c},客场上衣:${away.a},客场短裤:${away.b},客场球袜:${away.c},主场守门员上衣:${home.d},主场守门员短裤:${home.e},主场守门员球袜:${home.f},客场守门员上衣:${away.d},客场守门员短裤:${away.e},客场守门员球袜:${away.f}`
        }
        params.matchId = this.projectId
        params.id = this.teamId
        updateBMMatchTeam(params).then(res => {
          if (res) {
            this.getBMMatchTeamSignup()
            Toast.success('保存成功')
            this.$router.push('/entry-page/entry-list?unionMatchId=' + this.unionMatchId)
          }
        })
      })
    },
    getAreaInfo(areaId, options, a) {
      if (!areaId) return ''
      for (let i = 0; i < options.length; i++) {
        if (options[i].id === areaId) {
          a.push(options[i].name)
          return true
        } else if (options[i].kids) {
          const b = this.getAreaInfo(areaId, options[i].kids, a)
          if (b) {
            a.push(options[i].name)
            return true
          }
        }
      }
      return false
    },
    showPlayerFun(type, p) {
      if (type === 'edit') {
        // if (this.project.isOpenCharge === 1 && p.orderStatus === 1) {
        //   Toast('已支付选手不允许编辑')
        //   return
        // }
        const player = JSON.parse(JSON.stringify(p)) || { certType: 1 }
        this.genderOld = player.gender
        player.bmBirthdayValue = player.bmBirthday && this.getFormatDate(player.bmBirthday) || ''

        if (player.certType && player.certType !== 11) {
          player.certTypeValue = certTypeColumns[player.certType - 1]
        } else if (player.certType && player.certType === 11) {
          player.certTypeValue = '学籍卡'
        } else player.certTypeValue = '身份证'

        if (player.certTypeValue === '身份证') {
          player.certType = 1
        }
        player.avatarList = player.avatar && [{ url: QNImageUtil.imageView(player.avatar), isImage: true }] || []
        player.IDCardPhotoAList = player.IDCardPhotoA && [{ url: QNImageUtil.imageView(player.IDCardPhotoA), isImage: true, hash: player.IDCardPhotoA }] || []
        player.IDCardPhotoBList = player.IDCardPhotoB && [{ url: QNImageUtil.imageView(player.IDCardPhotoB), isImage: true, hash: player.IDCardPhotoB }] || []
        if (player.qualificationFile && player.qualificationFile.length > 0) {
          const a = player.qualificationFile.split(',') || []
          player.qualificationFileList = []
          a.forEach(item => {
            player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
          })
        } else {
          player.qualificationFileList = []
        }
        if (player.insureFile && player.insureFile.length > 0) {
          const a = player.insureFile.split(',') || []
          player.insureFileList = []
          a.forEach(item => {
            player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
          })
        } else {
          player.insureFileList = []
        }
        const a = []
        this.getAreaInfo(player.domicileAreaId, this.options, a)
        a.reverse()
        player.domicileAreaName = a.join('/')
        this.player = player
        this.currentDate = new Date(player.bmBirthday)
      } else {
        if (this.players.length < this.project.teamMemberLimitCount) {
          this.player = {}
          this.currentDate = this.minDate
        } else {
          Toast.fail('队员添加已达上限')
          return
        }
      }
      this.type = type
      this.showPlayer = true
      this.$nextTick(() => {
        const playerPopup = document.querySelector('.player-popup')
        playerPopup.scrollTop = 0
      })
    },
    savePlayer() {
      if (this.playerCheckboxes.gender && (this.project.genderLimit != 0 && this.project.genderLimit != 3) && this.player.gender != this.project.genderLimit) {
        Toast({ type: 'fail', message: '性别异常' })
        return
      }
      if (this.playerCheckboxes.jerseysSize && !this.player.jerseysSize) {
        return Toast({ message: '请选择球衣尺码' })
      }
      this.$refs.playerForm.validate().then(() => {
        if (this.type === 'edit') {
          const params = JSON.parse(JSON.stringify(this.player))
          params.matchId = this.projectId
          params.genderOld = this.genderOld
          delete params.avatarList
          delete params.IDCardPhotoAList
          delete params.IDCardPhotoBList
          delete params.qualificationFileList
          delete params.insureFileList
          delete params.showPlayerInfo
          delete params.domicileAreaName
          delete params.bmBirthdayValue
          delete params.certTypeValue
          if (!params.serialNumber) params.serialNumber = '_'
          updateBMMatchTeamPlayer(params).then(res => {
            if (res) {
              this.getPlayers()
              Toast.success('更新成功')
              this.showPlayer = false
            }
          })
        } else {
          const params = JSON.parse(JSON.stringify(this.player))
          params.id = this.teamId
          params.matchId = this.projectId
          delete params.avatarList
          delete params.IDCardPhotoAList
          delete params.IDCardPhotoBList
          delete params.qualificationFileList
          delete params.insureFileList
          delete params.showPlayerInfo
          delete params.domicileAreaName
          delete params.bmBirthdayValue
          delete params.certTypeValue
          if (!params.serialNumber) params.serialNumber = '_'
          createBMMatchTeamPlayer(params).then(res => {
            if (res) {
              this.getPlayers()
              Toast.success('保存成功')
              this.showPlayer = false
            }
          })
        }
      })
    },
    showOfficerFun(type, officer) {
      if (type === 'edit') {
        console.log(officer);
        if (officer.certificateType) {
          let name = this.optionsClass.find(item => item.value === officer.certificateType)
          let name2 = name.text + '/' + name.children.find(item => item.value === officer.certificateLevel).text
          officer.certificateTypeText = name2
          this.certificateTypeText = officer.certificateLevel
        }
        this.officer = JSON.parse(JSON.stringify(officer))
        this.$set(this.officer, 'avatarList', [{ url: QNImageUtil.imageView(officer.avatar), isImage: true }])
      } else {
        if (this.officers.length >= this.project.maxOffice) {
          Toast.fail('工作人员添加已达上限')
          return
        }
        this.officer = {}
      }
      this.type = type
      this.showOfficer = true
    },
    saveOfficer() {
      this.$refs.officerForm.validate().then(() => {
        if (this.type === 'edit') {

          console.log(this.officer.role);
          if (this.officer.role !== '教练' && this.officer.role !== '主教练') {
            console.log(111);
            this.officer.certificateType = ''
            this.officer.certificateLevel = ''
          }
          const params = {
            ...this.officer
          }
          delete params.avatarList
          updateBMMatchTeamOffice(params).then(res => {
            if (res) {
              this.getOfficers()
              Toast.success('更新成功')
              this.showOfficer = false
            }
          })
        } else {
          const params = {
            matchId: this.projectId,
            teamId: this.teamId,
            ...this.officer
          }
          delete params.avatarList
          createBMMatchTeamOffice(params).then(res => {
            if (res) {
              this.getOfficers()
              Toast.success('保存成功')
              this.showOfficer = false
            }
          })
        }
      })
    },
    goEntryList() {
      this.$router.push('/entry-page/entry-list?unionMatchId=' + this.unionMatchId)
    },
    continueFinish() {
      this.showDialog = false
    },
    onConfirm(value) {
      this.officer.role = value
      this.showRoles = false
    },
    onCancel() {
      this.showRoles = false
    },
    showRolesFun() {
      const index = this.roleColumns.findIndex(item => item === this.officer.role)
      this.defaultIndex = index > -1 ? index : 0
      this.showRoles = true
    },
    showCertTypeFun() {
      this.showCertType = true
    },
    onConfirmCertType(value) {
      this.player.certTypeValue = value.label
      this.player.certType = value.value
      this.showCertType = false
    },
    onCancelCertType() {
      this.showCertType = false
    },
    onConfirmNationality(value) {
      this.player.nationalityValue = value
      const item = nationalityOption.find(i => i.label === value)
      this.player.nationality = item.value
      this.showNationality = false
    },
    onCancelNationality() {
      this.showNationality = false
    },
    onConfirmHomeColor(value) {
      const team = JSON.parse(JSON.stringify(this.team))
      team.homeClothesColor = value.value
      team.homeClothesColorImg = value.img
      this.team = team
      this.showHomeColor = false
    },
    onCancelHomeColor() {
      this.showHomeColor = false
    },
    onConfirmAwayColor(value) {
      const team = JSON.parse(JSON.stringify(this.team))
      team.awayClothesColor = value.value
      team.awayClothesColorImg = value.img
      this.team = team
      this.showAwayColor = false
    },
    onCancelAwayColor() {
      this.showAwayColor = false
    },
    showNationalityFun() {
      const index = this.nationalityColumns.findIndex(item => item === this.player.nationalityValue)
      this.defaultNationalityIndex = index > -1 ? index : 0
      this.showNationality = true
    },
    deletePlayer(id) {
      const params = {
        id: id,
        matchId: this.projectId
      }
      deleteBMMatchTeamPlayer(params).then(res => {
        if (res) {
          Toast.success('删除成功')
          this.getPlayers()
        }
      })
    },
    deleteOfficer(id) {
      const params = {
        id: id
      }
      deleteBMMatchTeamOffice(params).then(res => {
        if (res) {
          Toast.success('删除成功')
          this.getOfficers()
        }
      })
    },
    getRandomNum(lbound, ubound) {
      return Math.floor(Math.random() * (ubound - lbound)) + lbound
    },
    setWXShare() {
      const shareObj = {
        title: this.team.name ? this.team.name : '' + '邀请',
        abstract: this.team.name ? this.team.name : '' + '邀请您参加' + this.project.group + '快来报名吧',
        link: process.env.VUE_APP_BM_MATCH + '#/entry-page/wx-invite-landing?unionMatchId=' + this.unionMatchId + '&matchId=' + this.projectId + '&teamId=' + this.teamId,
        image: this.match.backgroundImage2 ? QNImageUtil.imageView(this.match.backgroundImage2) : ''
      }
      this.wxShare(shareObj)
    },
    async weChatShare() {
      if (!this.showButton) return Toast.fail('通过审核的球队不支持添加球员')
      
      // 先判断是否在微信环境
      if (!AppType.isInWeChat()) {
        Toast.fail('请在微信环境下打开')
        return
      }
      
      // 判断是否为微信小程序环境
      const isMiniApp = await isWeChatMiniApp()
      
      if (isMiniApp) {
        // 微信小程序环境
        wx.miniProgram.navigateTo({
          url: `/pages/share/index?unionMatchId=${this.unionMatchId}&matchId=${this.projectId}&teamId=${this.teamId}`
        })
      } else {
        // 微信浏览器环境
        this.shareShow = true
        const shareObj = {
          title: this.team.name + '邀请您加入',
          abstract: this.team.name + '邀请您参加' + this.match.chineseName + '/' + this.project.group + '的比赛',
          link: process.env.VUE_APP_BM_MATCH + '#/entry-page/wx-invite-landing?unionMatchId=' + this.unionMatchId + '&matchId=' + this.projectId + '&teamId=' + this.teamId,
          image: this.match.backgroundImage2 ? QNImageUtil.imageView(this.match.backgroundImage2) : ''
        }
        this.wxShare(shareObj)
      }
    }
  }
}
</script>

<style lang="scss">
.entry-info {
  min-height: 100vh;

  .project {
    padding: 16px 12px 12px 12px;
    margin-bottom: 12px;
    background-color: #F8F8F8;
    border-radius: 4px;

    .top {
      display: flex;
      justify-content: space-between;

      .left {
        .group {
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;

          .entryType {
            background-color: #FF652A;
            color: #FFFFFF;
            border-radius: 2px;
            display: inline-block;
            height: 20px;
            width: 32px;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
          }

          .group-name {
            font-size: 16px;
            height: 20px;
            color: #333333;
          }
        }

        .row {
          display: flex;
          align-items: center;
          padding: 0 0 5px 0;

          .base-box {
            width: 20px;
            height: 20px;
            background-color: #FBEFEA;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .info {
            font-size: 12px;
            color: #8C8C8C;
          }

          .col {
            display: flex;
            height: 20px;
            width: 82px;
            line-height: 20px;

            .icon {
              width: 20px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              background-color: #1565FC;
              font-size: 12px;
              font-weight: 500;
              color: #FFFFFF;
            }
          }
        }
      }

      .right {
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .line {
      margin: 4px 0 10px 0;
      height: 1px;
      background-color: #F3F3F3;
    }

    .bottom1 {
      .row {
        display: flex;
        justify-content: space-between;

        .base-box {
          width: 20px;
          height: 20px;
          background-color: #FBEFEA;
          border-radius: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .info {
          font-size: 12px;
          color: #8C8C8C;
        }

        .col {
          display: flex;
          height: 20px;
          line-height: 20px;

          .icon {
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background-color: #1565FC;
            font-size: 12px;
            font-weight: 500;
            color: #FFFFFF;
          }

          .price {
            height: 20px;
            width: 68px;
            text-align: center;
            line-height: 20px;
            background-color: #E5EDFF;
            font-size: 12px;
            font-weight: 500;
            color: #1565FC;
            border-radius: 0 3px 3px 0;
          }

          .num {
            font-size: 14px;
            color: #8C8C8C;
          }
        }
      }
    }
  }

  .tabs {
    .title {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      padding: 25px 0 13px 0;
      margin: 0 16px;
      border-bottom: 0.5px #EEEEEE solid;

      .icon {
        width: 2px;
        height: 12px;
        background-color: #7CCD19;
        margin-right: 6px;
      }
    }

    .notice {
      height: 38px;
      padding: 0 12px;
      font-size: 11px;
      color: #191919;
      background-color: #FEF8F6;
      display: flex;
      align-items: center;
    }

    .actions {
      display: flex;
      justify-content: space-between;
      margin: 10px 12px 12px 12px;

      .action {
        width: 30%;
        padding: 12px 0 8px 0;
        background-color: #F5F8FF;

        .item {
          display: flex;
          justify-content: center;
          color: #8C8C8C;
          font-size: 12px;
        }
      }
    }

    .clotheses {
      padding: 12px 16px;
      overflow-x: auto;
      white-space: nowrap;

      .clothes {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 60px;
        margin-right: 8px;
        border-radius: 4px;
        background-color: #DFDFDF;
        box-sizing: border-box;

        .img {
          width: 60px;
          height: 60px;
        }

        .disabled {
          position: absolute;
          top: 0;
          width: 60px;
          height: 60px;
          border-radius: 4px;
          background-color: #000000;
          opacity: 0.3;
          display: flex;
          align-items: center;
          justify-content: center;

          .lock {
            width: 16px;
            height: 16px;
          }
        }
      }

      .selected {
        box-sizing: border-box;
        box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, .3);
      }
    }

    .players {
      padding: 16px;

      .player {
        padding: 16px 12px;
        margin-bottom: 12px;
        background-color: #FAFAFC;

        .row {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .left {
            display: flex;
            align-items: center;

            .index {
              font-size: 16px;
              font-weight: 500;
              color: #333333;
              margin-right: 8px;
            }

            .true-name {
              font-size: 16px;
              font-weight: 500;
              color: #333333;
              margin-right: 8px;
            }
          }

          .info {
            font-size: 14px;
            color: #8C8C8C;
          }
        }
      }
    }

    .limit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 52px;
      margin: 0 22px 0 16px;
      border-bottom: 1px #EEEEEE solid;

      .description {
        font-size: 14px;
        color: #5B5B5B;
      }
    }

    .officers {
      padding: 16px;

      .officer {
        padding: 16px 12px;
        margin-bottom: 12px;
        background-color: #FAFAFC;

        .row {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .left {
            display: flex;

            .index {
              font-size: 16px;
              font-weight: 500;
              color: #333333;
              margin-right: 8px;
            }

            .name {
              font-size: 16px;
              font-weight: 500;
              color: #333333;
              margin-right: 8px;
            }

            .boy-role {
              min-width: 60px;
              padding-right: 4px;
              height: 20px;
              background-color: #E5EDFF;
              color: #1565FC;
              font-size: 15px;
              display: flex;
              align-items: center;
              border-radius: 2px;
            }

            .girl-role {
              width: 60px;
              height: 20px;
              background-color: #F9E8EA;
              color: #F95252;
              font-size: 15px;
              display: flex;
              align-items: center;
              border-radius: 2px;
            }
          }

          .info {
            font-size: 14px;
            color: #8C8C8C;
          }
        }
      }
    }

    .delete-button {
      height: 100%;
      border-radius: 0 4px 4px 0;
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 14px 12px 12px 12px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .popup {
    .title {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      padding: 25px 0 13px 0;
      margin: 0 16px;
      border-bottom: 0.5px #EEEEEE solid;

      .icon {
        width: 2px;
        height: 12px;
        background-color: #7CCD19;
        margin-right: 6px;
      }
    }
  }

  .player-popup {}
}

.notice {
  .notice-title {
    text-align: center;
    font-size: 16px;
    padding: 12px 0;
    // border-bottom: 1px solid #f3f3f3;
  }

  .info {
    padding: 12px;
    white-space: pre-wrap;
  }

  .close {
    text-align: center;
    color: #576B95;
    // border-top: 1px solid #f3f3f3;
    padding: 12px 0;
  }

  .disabled {
    color: #999 !important;
  }
}

::v-deep .my-imgs {
  width: 100%;
}
</style>
